import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-html',
    template: `
    <ckeditor
            [class.ng-dirty]="showError"
            [formControl]="formControl"
            [formlyAttributes]="field"
            [disableTwoWayDataBinding]="false"
            [editor]="Editor"
            id="description"
            name="description">
    </ckeditor>
  `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldHtml extends FieldType {
    public Editor = ClassicEditor;
}
